const axios = require('axios');

async function getAllFormations(consdition) {
  try {
    const resData = await axios.get('/api/v1/admin/formation/all', { params: consdition });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function findformationById(id) {
  try {
    const resData = await axios.get('/api/v1/admin/formation', { params: { id } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateFormation(params) {
  try {
    const resData = await axios.put('/api/v1/admin/formation', params);
    return resData;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { getAllFormations, findformationById, updateFormation };
